// extracted by mini-css-extract-plugin
export default {"list":"DWwWpx","item":"rClIE4"};